export const showWishListModal = (showing = false, isFavorite = false) => {
    return {
      type : 'SHOW_WISH_LIST_MODAL',
      showing: showing,
      isFavorite: isFavorite
    }
  };
  